module.exports = __webpack_public_path__ + "img/background_c5_mobile.177a2921.png";